import { render, staticRenderFns } from "./InspirationMedia.vue?vue&type=template&id=c49422dc"
import script from "./InspirationMedia.vue?vue&type=script&lang=ts"
export * from "./InspirationMedia.vue?vue&type=script&lang=ts"
import style0 from "./InspirationMedia.vue?vue&type=style&index=0&id=c49422dc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports